module.exports = __webpack_public_path__ + "static/media/BlueStarIcon.4eef4111.svg";